/**
 * PLAT-10046 — render an ISO timestamp as a short, locale-aware
 * "M/D/YY h:MM AM/PM" string for pin-detail / edit-history cards.
 *
 * Returns an empty string on parse failure (rather than echoing the raw
 * input) so the surface doesn't render garbage like
 * `"2026-99-99T..."`. Callers must combine the result with their own
 * "on" connector via an explicit check (see `CompositionQuickEditPopover`
 * pin-detail card: `pinnedAt ? \` on \${formatPinnedAt(pinnedAt)}\` : ''`).
 */
export function formatPinnedAt(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  const d = new Date(t);
  return d.toLocaleString(undefined, {
    month: 'numeric',
    day: 'numeric',
    year: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
  });
}
